import clsx from 'clsx'
import {useLayout, usePageData} from '../core'
import {DefaultTitle} from './header/page-title/DefaultTitle'
import Button from 'components/shared/buttons'

const Toolbar = () => {
  const {classes} = useLayout()
  const {pageMenu} = usePageData()

  return (
    <div className='toolbar' id='kt_toolbar'>
      <div
        id='kt_toolbar_container'
        className={clsx(classes.toolbarContainer.join(' '), 'd-flex flex-stack')}
      >
        <DefaultTitle />

        <div className='d-flex align-items-center gap-3'>
          {pageMenu?.map((item, index) => (
            <Button
              key={index}
              label={item.label}
              onClick={item.onClick}
              styleType={item.styleType || 'primary'}
              type='button'
              className='btn-sm'
            />
          ))}
        </div>
      </div>
    </div>
  )
}

export {Toolbar}
